import { render, staticRenderFns } from "./JobCommentForm.vue?vue&type=template&id=23e6a226&scoped=true"
import script from "./JobCommentForm.vue?vue&type=script&lang=js"
export * from "./JobCommentForm.vue?vue&type=script&lang=js"
import style0 from "./JobCommentForm.vue?vue&type=style&index=0&id=23e6a226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e6a226",
  null
  
)

export default component.exports